(() => {
  function init(scope = document) {
    const root = scope.querySelector('[data-um22]');
    if (!root || root.dataset.um22Ready) return;
    root.dataset.um22Ready = 'true';
    const videos = [...root.querySelectorAll('video')];
    const choices = [...root.querySelectorAll('[data-um22-select]')];
    const panels = [...root.querySelectorAll('[data-um22-panel]')];
    const select = (name) => {
      videos.forEach(video => video.pause());
      choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.um22Select === name)));
      panels.forEach(panel => { panel.hidden = panel.dataset.um22Panel !== name; });
    };
    choices.forEach(button => button.addEventListener('click', () => select(button.dataset.um22Select)));
    document.querySelectorAll('[data-um22-jump]').forEach(link => {
      link.addEventListener('click', () => {
        select(link.dataset.um22Jump);
        choices.find(button => button.dataset.um22Select === link.dataset.um22Jump)?.focus({preventScroll:true});
      });
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
    }, {threshold:0.05});
    videos.forEach(video => {
      observer.observe(video);
      video.addEventListener('play', () => videos.forEach(other => { if (other !== video) other.pause(); }));
      const error = video.parentElement.querySelector('.um22-error');
      const failed = () => { if (error) error.hidden = false; };
      video.addEventListener('error', failed);
      video.querySelector('source')?.addEventListener('error', failed);
      video.addEventListener('loadeddata', () => { if (error) error.hidden = true; });
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) videos.forEach(video => video.pause());
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
